import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15 21h-3v-2h2v-5h5V5H5v6H3V5c0-.55.196-1.021.587-1.413A1.93 1.93 0 0 1 5 3h14c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v10l-6 6Z" }, null, -1),
    _createElementVNode("path", { d: "M8 18v3H6v-3H3v-2h3v-3h2v3h3v2H8Z" }, null, -1)
  ]))]))
}
export default { render: render }